import { motion } from 'framer-motion';

export default function Terms() {
  return (
    <div className="min-h-screen pt-16">
      <section className="py-24 bg-gradient-to-br from-night-900 via-night-800 to-night-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-launch-blue via-launch-purple to-launch-orange bg-clip-text text-transparent">
                Terms of Service
              </span>
            </h1>
            <p className="text-offwhite/60">Last updated: {new Date().toLocaleDateString()}</p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 bg-night-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert prose-launch max-w-none">
            <div className="space-y-8 text-offwhite/80">
              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">1. Services</h2>
                <p>
                  Cloud Launch provides technical web development services including custom Next.js/TypeScript 
                  development, Shopify builds, WordPress development, and technical support retainers. All 
                  services are subject to these terms and any additional agreements made in writing.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">2. Payment Terms</h2>
                <p>
                  Services are billed at the rates specified in our pricing structure. Payment terms are 
                  net 14 days unless otherwise agreed. All prices are in Australian Dollars and exclude GST.
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                  <li>Technical Support: AU$180/hr ex GST</li>
                  <li>Application Dev Support: AU$220/hr ex GST</li>
                  <li>Web Dev Projects: AU$150/hr ex GST (20 hour minimum)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">3. Project Scope</h2>
                <p>
                  All projects begin with a discovery phase to define scope and requirements. Changes to 
                  agreed scope will be documented and may result in additional charges. We work iteratively 
                  and maintain open communication throughout the project lifecycle.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">4. Intellectual Property</h2>
                <p>
                  Upon full payment, clients receive ownership of custom code developed specifically for 
                  their project. Cloud Launch retains rights to general frameworks, tools, and methodologies 
                  used across projects.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">5. Support & Maintenance</h2>
                <p>
                  Technical support retainers include priority response times and monthly check-ins. 
                  Specific SLA terms are defined in individual retainer agreements. Post-launch support 
                  is available for all projects.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">6. Confidentiality</h2>
                <p>
                  We maintain strict confidentiality of all client information and project details. 
                  Non-disclosure agreements are available upon request.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">7. Limitation of Liability</h2>
                <p>
                  Cloud Launch's liability is limited to the fees paid for the specific service in question. 
                  We maintain professional indemnity insurance for additional protection.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">8. Termination</h2>
                <p>
                  Either party may terminate services with 30 days written notice. Clients are responsible 
                  for payment of all work completed up to the termination date.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-offwhite mb-4">9. Contact</h2>
                <p>
                  For questions regarding these terms, please contact us at:
                  <br />
                  <a href="mailto:legal@cloudlaunch.com" className="text-launch-blue hover:text-launch-purple">
                    legal@cloudlaunch.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
